<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.CARGOTYPENAME"
        nolabel
        :placeholder="$t('search.cargotype')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        CARGOTYPENAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        CARGOTYPENAME: null,
      };
    },
  },
};
</script>

<style></style>
